export default {
    dsRegional: {
        label: 'Regional',
        field: 'dsRegional',
        type: 'general',
        align: 'left',
        customWidth: 220,
        fixed: false,
        render: true,
        disableOrder: false
    },
    branch: {
        label: 'Loja',
        field: 'branch',
        type: 'general',
        align: 'left',
        customWidth: 220,
        fixed: false,
        render: true,
        disableOrder: false
    },
    dataCreation: {
        label: 'Data',
        field: 'dataCreation',
        type: 'general',
        align: 'left',
        customWidth: 120,
        fixed: false,
        render: true,
        disableOrder: false
    },
    dataCreationHour: {
        label: 'Hora da solicitação',
        field: 'dataCreationHour',
        align: 'left',
        type: 'wrapLine',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true
    },
    dataVerificationHour: {
        label: 'Hora da verificação',
        field: 'dataVerificationHour',
        align: 'left',
        type: 'wrapLine',
        customWidth: 92,
        fixed: false,
        render: true,
        disableOrder: true
    },
    dataApproveHour: {
        label: 'Hora da confirmação',
        field: 'dataApproveHour',
        align: 'left',
        type: 'wrapLine',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true
    },
    cdLm: {
        label: 'LM',
        field: 'cdLm',
        align: 'left',
        type: 'general',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true
    },
    desc: {
        label: 'Descrição',
        field: 'desc',
        align: 'left',
        type: 'general',
        customWidth: 170,
        fixed: false,
        render: true,
        disableOrder: true,
        fullWidth: true,
    },
    section: {
        label: 'Seção',
        field: 'section',
        align: 'left',
        type: 'general',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true,
        fullWidth: true
    },
    dsSectionConsume: {
        label: 'Departamento solicitante',
        field: 'dsSectionConsume',
        align: 'left',
        type: 'general',
        customWidth: 190,
        fixed: false,
        render: true,
        fullWidth: true,
        disableOrder: true
    },
    initialStock: {
        label: 'Estoque disponível',
        field: 'initialStock',
        align: 'left',
        type: 'wrapLine',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true
    },
    qtyRequested: {
        label: 'Quantidade solicitada',
        field: 'qtyRequested',
        align: 'left',
        type: 'wrapLine',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true
    },
    valueRequested: {
        label: 'Valor solicitado',
        field: 'valueRequested',
        align: 'left',
        type: 'wrapLine',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true
    },
    finalStock: {
        label: 'Estoque final',
        field: 'finalStock',
        align: 'left',
        type: 'wrapLine',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true
    },
    invoiceNumber: {
        label: 'Número da nota fiscal',
        field: 'invoiceNumber',
        align: 'left',
        type: 'wrapLine',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true
    },
    invoiceValue: {
        label: 'Valor da nota fiscal',
        field: 'invoiceValue',
        align: 'left',
        type: 'wrapLine',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true
    },
    ldapRequest: {
        label: 'LDAP - Solicitação',
        field: 'ldapRequest',
        align: 'left',
        type: 'general',
        customWidth: 140,
        fixed: false,
        render: true,
        fullWidth: true,
        disableOrder: true
    },
    ldapVerifier: {
        label: 'LDAP - Verificador',
        field: 'ldapVerifier',
        align: 'left',
        type: 'general',
        customWidth: 140,
        fixed: false,
        render: true,
        fullWidth: true,
        disableOrder: true
    },
    ldapApprover: {
        label: 'LDAP - Aprovação',
        field: 'ldapApprover',
        align: 'left',
        type: 'general',
        customWidth: 140,
        fixed: false,
        render: true,
        fullWidth: true,
        disableOrder: true
    },
    reasonRequest: {
        label: 'Motivo da solicitação',
        field: 'reasonRequest',
        align: 'left',
        type: 'general',
        customWidth: 160,
        fixed: false,
        render: true,
        fullWidth: true,
        disableOrder: true
    },
    reasonReprove: {
        label: 'Motivo da reprovação',
        field: 'reasonReprove',
        align: 'left',
        type: 'general',
        customWidth: 160,
        fixed: false,
        render: true,
        disableOrder: true,
        fullWidth: true
    },
    observation: {
        label: "Observação",
        field: "observation",
        align: "left",
        type: "general",
        customWidth: 180,
        fullWidth: true,
        fixed: false,
        render: true,
        disableOrder: true
    },
    status: {
        label: 'Status',
        field: 'status',
        align: 'left',
        type: 'general',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true
    },
};
